import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {lastNewsletterModalShownSelector, setLastNewsletterModalShown, userSelector} from '../../model/authSlice';
import SubscribeModal from '../SubscribeModal/SubscribeModal';

const NewsletterPopup: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const user = useSelector(userSelector);
    const lastShown = useSelector(lastNewsletterModalShownSelector);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!user || user.shown_newsletter_popup) return;

        const now = Date.now();
        const oneDay = 24 * 60 * 60 * 1000;
        const lastShownTime = Number(localStorage.getItem('lastNewsletterModalShown') || '0');
        if (lastShown !== lastShownTime) {
            dispatch(setLastNewsletterModalShown(lastShownTime));
        }
        const shouldShow = !lastShownTime || (now - lastShownTime) > oneDay;

        // eslint-disable-next-line react-hooks/set-state-in-effect
        setIsOpen(shouldShow);
    }, [user, lastShown, dispatch]);

    const handleClose = (responded: boolean) => {
        setIsOpen(false);
        if (!responded) {
            const timestamp = Date.now();
            dispatch(setLastNewsletterModalShown(timestamp));
            localStorage.setItem('lastNewsletterModalShown', timestamp.toString());
        }
    };

    if (!user) {
        return null;
    }

    return (
        <SubscribeModal
            userId={user.id}
            isOpen={isOpen}
            onClose={handleClose}
        />
    );
};

export default NewsletterPopup;
